import React from "react";
import { action } from "store/Project";
import { connect } from "react-redux";
import { Select, Row, Col, Button, Checkbox, InputNumber, Tag } from "antd";

import { List } from "immutable";

class SubStep extends React.Component {
  render() {
    const selectedNormals = this.props.newTable.get("normal", new List());

    return (
      <div>
        {selectedNormals.map((normal) => {
          const subs = this.props.factorList
            .get("sub", new List())
            .filter((f) => f.get("parent_id") === normal.get("id"));
          const selectedSubs = this.props.newTable
            .get("sub", new List())
            .filter((f) => f.get("parent_id") === normal.get("id"));
          return (
            <div className="sub-item" key={`normal${normal.get("id")}`}>
              <Row gutter={15}>
                <Col span={8}>{normal.get("name")}</Col>
                <Col span={10}>
                  <Select
                    showSearch
                    mode="multiple"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="请选择因子"
                    style={{ width: "100%" }}
                    value={this.props.currentSelect.getIn([
                      "sub",
                      normal.get("id")
                    ])}
                    onChange={(value) =>
                      this.props.changeCurrectSelect(normal.get("id"), value)
                    }
                  >
                    {subs.map((sub) => (
                      <Select.Option
                        key={`sub${sub.get("id")}`}
                        value={sub.get("id")}
                      >
                        {sub.get("name")}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
                <Col span={4}>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    onClick={() => this.props.addSub(normal.get("id"))}
                  >
                    添加
                  </Button>
                </Col>
              </Row>

              {selectedSubs.map((selectedSub, selectedSubIndex) => (
                <Row
                  gutter={15}
                  style={{ marginTop: "1em" }}
                  key={`sub${selectedSub.get("id")}`}
                >
                  <Col span={7}>
                    {selectedSubIndex + 1}. {selectedSub.get("name")}
                  </Col>
                  <Col span={4}>
                    <Checkbox
                      style={{ marginLeft: 10 }}
                      onChange={(e) => {
                        let newSub = selectedSub.set(
                          "status",
                          e.target.checked ? 0 : 1
                        );
                        let subIndex = this.props.newTable
                          .get("sub")
                          .findIndex((f) => f.get("id") === newSub.get("id"));
                        this.props.changeSub(subIndex, newSub);
                      }}
                      checked={selectedSub.get("status", 1) !== 1}
                    >
                      不用填（100分）
                    </Checkbox>
                  </Col>
                  <Col span={4}>
                    <InputNumber
                      size="small"
                      style={{ width: "100%" }}
                      min={0}
                      max={100}
                      placeholder="建议分值"
                      value={selectedSub.get("suggest_score")}
                      onChange={(value) => {
                        let newSub = selectedSub.set(
                          "suggest_score",
                          value
                        );
                        let subIndex = this.props.newTable
                          .get("sub")
                          .findIndex((f) => f.get("id") === newSub.get("id"));
                        this.props.changeSub(subIndex, newSub);
                      }}
                    />
                  </Col>
                  <Col span={4}>
                    <Button
                      type="danger"
                      onClick={() =>
                        this.props.removeSub(selectedSub.get("id"))
                      }
                    >
                      移除
                  </Button>
                </Col>
              </Row>
            ))}
            {(() => {
              const fillable = selectedSubs.filter(
                (s) => s.get("status", 1) !== 0
              );
              // 没有需要填的项（整组未添加 / 全部勾了"不用填"）时不展示合计
              if (fillable.size === 0) {
                return null;
              }
              const total = fillable.reduce(
                (acc, s) => acc + (Number(s.get("suggest_score")) || 0),
                0
              );
              return (
                <Row gutter={15} style={{ marginTop: "1em" }}>
                  <Col span={4} offset={11}>
                    <Tag
                      color={total === 100 ? "green" : "red"}
                      style={{ fontWeight: 600 }}
                    >
                      建议分值合计：{total}
                    </Tag>
                  </Col>
                </Row>
              );
            })()}
          </div>
          );
        })}
      </div>
    );
  }
}

const STP = (state) => {
  return {
    factorList: state.getIn(["project", "factorList"]),
    newTable: state.getIn(["project", "newTable"]),
    currentSelect: state.getIn(["project", "currentSelect"])
  };
};

const DTP = (dispatch) => {
  return {
    changeCurrectSelect: (normalId, value) => {
      dispatch(action.changeItem(["currentSelect", "sub", normalId], value));
    },
    addSub: (normalId) => {
      dispatch(action.addSub(normalId));
    },
    changeSub: (subIndex, newSub) => {
      dispatch(action.changeItem(["newTable", "sub", subIndex], newSub));
    },
    removeSub: (subId) => {
      dispatch(action.removeSub(subId));
    }
  };
};

export default connect(STP, DTP)(SubStep);
